import { createStore } from '@souche-f2e/muji';

const state = {
  docId: '',
}

export default createStore({
  state,
  reducers: {
    UPDATE_ROUTE(state, payload) {
      return {
        ...state,
        ...payload
      }
    },
  },
  effects: {
    updatePath(payload, { state, rootState }) {
      this.UPDATE_ROUTE(payload)
    }
  },
  async setup({ history }) {
    history.listen(route => {
      if (route.path === '/documents/docking_process')  {
        let { docId } = route.query;
        docId = Number(docId);
        this.updatePath({
          docId: docId || 0,
        });
    }
    })
  },
});